// extracted by mini-css-extract-plugin
export default {"BrowserTree":"SchemaBrowser_BrowserTree__nYQ9h","Browser__Loading":"SchemaBrowser_Browser__Loading__JNcMp"};